import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkSlash } from '@rq-ratings/pro-solid-svg-icons'
import { useMutation } from '@tanstack/react-query'
import React from 'react'

import ActionButton from '../../../../components/misc/ActionButton'
import { useCompanyNylasIntegrationQuery } from '../../../../hooks/useCompanyNylasIntegrationQuery'
import useNotyf from '../../../../hooks/useNotyf'
import companyIntegrationService from '../../../../lib/services/companyIntegrationService'

interface Props {
  disabled: boolean
  onMutationStarted: () => void
  onDeleted: () => void
  onError: () => void
}

const DisconnectCompanyEmailButton: React.FC<Props> = ({
  disabled,
  onMutationStarted,
  onDeleted,
  onError,
}) => {
  const confirmMessage =
    "Disconnect your company's email account? Referral and other emails will no longer be sent via this account"

  const companyNylasIntegrationQuery = useCompanyNylasIntegrationQuery()
  const companyNylasIntegration = companyNylasIntegrationQuery.data

  const notyf = useNotyf()

  const disconnectMutation = useMutation({
    mutationFn: async (companyIntegrationId: number) =>
      companyIntegrationService.disconnectCompanyEmail(companyIntegrationId),
    onMutate: onMutationStarted,
    onSuccess: onDeleted,
    onError: () => {
      notyf.error('Disconnect failed. Please try again.')
      onError()
    },
  })

  if (companyNylasIntegration === undefined) {
    return null
  }

  return (
    <ActionButton
      isProcessing={disconnectMutation.isPending}
      isProcessingText="Disconnecting"
      variant="outline-danger"
      size="sm"
      onClick={() => {
        if (window.confirm(confirmMessage)) {
          disconnectMutation.mutate(companyNylasIntegration.id)
        }
      }}
      disabled={disabled}
    >
      <FontAwesomeIcon icon={faLinkSlash} className="me-2" />
      Disconnect email
    </ActionButton>
  )
}

export default DisconnectCompanyEmailButton
